<template>
<div>
    <div class="exam-list app-body">
        <page-header></page-header>
        <scree-compent title="考试作业"></scree-compent>
        <div class="xy-center jf-start exam-class">
            <label>类型：</label>
            <div class="auto-grow xy-start">
                <div class="class-item"
                     :class="{'active': examType ===0}"
                     @click="changeClass(0)"
                >全部</div>
                <div class="class-item"
                     :class="{'active': examType ===1}"
                     @click="changeClass(1)">考试</div>
                <div class="class-item"
                     :class="{'active': examType ===2}"
                     @click="changeClass(2)">作业</div>
            </div>
        </div>
        <div class="bottom">
            <div class="nav xy-between">
                <div class="nav-tive jf">
                    <div
                        v-for="(item, index) in tabs"
                        :key="index"
                        class="topic xy-center"
                        :class="{'avtie' :cTab === item.val }"
                        @click="cTab = item.val">
                        <div class="yx-center">
                            <div class="cursor">{{ item.name }}</div>
                            <div class="throw" v-if="cTab === item.val"></div>
                        </div>
                    </div>
                </div>
                <div class="search">
                    <el-input placeholder="请输入关键字检索" v-model="searchKey"
                        @change="loadExamList(true)"
                    >
                        <template slot="append" @click="loadExamList(true)">
                            <i class="el-icon-search"></i>
                            <span class="cursor">搜索</span>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="list-body" v-if="list.length > 0">
                <div v-for="(item, index) in list" :key="item.ExamId" class="exam-item xy-center">
                    <div class="exam-no">{{ getBigIndex(index) }}</div>
                    <div class="auto-grow">
                        <div class="font-size18 c-333 one-wrap" style="font-weight: 500;margin-bottom: 20px">
                            {{ item.ExamName }}
                        </div>
                        <div class="info xy-start">
                            <div class="till">
                                <div class="info-item">
                                    <label>开始时间：</label><span>{{ item.BeginTime }}</span>
                                </div>
                                <div class="info-item">
                                    <label>总分：</label><span>{{ parseInt(item.TotalScore) }}</span>
                                </div>
                            </div>
                            <div class="till">
                                <div class="info-item">
                                    <label>结束时间：</label><span>{{ item.EndTime }}</span>
                                </div>
                                <div class="info-item">
                                    <label>题量：</label><span>{{ item.SubjectNum }}</span>
                                </div>
                            </div>
                            <div class="till">
                                <div class="info-item">
                                    <label>考试时长：</label>
                                    <span>{{ item.ExamTime === "0" ? "不限时长" : item.ExamTime + "分钟" }}</span>
                                </div>
                                <div class="info-item">
                                    <label>考试人员：</label>
                                    <span class="groupName" v-if="item.groupName">{{ item.groupName }}</span>
                                    <span class="groupName" v-else>--</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button v-if="item.btnStatus === btnTypes.startExam" @click="startExam(item)">开始考试</button>
                    <button v-else-if="item.btnStatus === btnTypes.restart" @click="startExam(item)">重新考试</button>
                    <button v-else-if="item.btnStatus === btnTypes.noStart" disabled>未开始</button>
                    <button v-else-if="item.btnStatus === btnTypes.examEnd" disabled>已结束</button>
                    <button v-else-if="item.btnStatus === btnTypes.examEd" disabled>已考试</button>
                </div>
            </div>
            <loading v-else-if="loading"></loading>
            <empty-data v-else></empty-data>
            <pagination
                hide-on-single-page="false"
                :pSize.sync="pageData.pagesize"
                :pageNo.sync="pageData.pageno"
                :total="pageData.total"
                @change="loadExamList"
            />
        </div>
    </div>
    <bottom-ground></bottom-ground>
    <exam-info ref="examDialog"></exam-info>
</div>
</template>

<script>
import PageHeader from "@/components/header";
import { GetExamLit, WriteCacheStartAnswer } from "@/api/exam";
import ScreeCompent from "@/components/screening";
import EmptyData from "@/components/EmptyData";
import Loading from "@/components/Loading";
import BottomGround from "@/components/bottomnav";
import ExamInfo from "@/components/exam/ExamInfo";
import examList from "@/mixins/examList";
export default {
    name: "index",
    mixins: [examList],
    components: { ExamInfo, Loading, EmptyData, PageHeader, ScreeCompent, BottomGround },
    data() {
        return {
            currentLibary: "per",
            cTab: "",
            searchKey: "",
            passClassId: "",
            examType: 0,
            pageData: {
                pageno: 1,
                pagesize: 10,
                total: 0
            },
            list: [],
            loading: false
        }
    },
    computed: {
        tabs() {
            return [
                { name: "全部", val: "" },
                { name: "未开始", val: "1" },
                { name: "考试中", val: "2" },
                { name: "已结束", val: "3" }
            ];
        }
    },
    watch: {
        cTab() {
            this.loadExamList(true);
        },
        passClassId() {
            this.loadExamList(true);
        }
    },
    created() {
        if (this.$store.getters.isLogin) {
            this.loadExamList()
        } else {
            this.$router.replace("/?login=1")
        }
    },
    methods: {
        async loadExamList(refresh) {
            this.loading = true
            this.list = []
            if (refresh) {
                this.pageData.pageno = 1;
            }
            let query = {
                ...this.pageData,
                ecid: 0,
                examType: this.examType
            }
            if (this.cTab) query.examState = this.cTab
            if (this.searchKey) query.examName = this.searchKey
            if (this.passClassId) query.ecid = this.passClassId
            // 这个默认的全部id有问题，直接删除
            if (this.passClassId === "1000") delete query.ecid
            try {
                let { data } = await GetExamLit(query);
                this.pageData.total = data.count
                this.handleExams(data.data)
                data.data.forEach(item => {
                    item.BeginTime = item.BeginTime.slice(0, 16);
                    item.EndTime = item.EndTime.slice(0, 16);
                });
                this.list = data.data;
            } finally {
                this.loading = false;
            }
        },
        // 改变分类， examType ： 1考试 2作业
        changeClass(examType) {
            if (examType !== this.examType) {
                this.examType = examType
                this.loadExamList(true)
            }
        },
        getBigIndex(index) {
            let i = (this.pageData.pageno - 1) * this.pageData.pagesize;
            return i + index + 1;
        },
        async startExam(val) {
            this.$refs.examDialog.show(val, true);
        }
    }
}
</script>

<style scoped lang="less">
.exam-list {
    .exam-class {
        background: white;
        padding: 0 30px 30px 30px;
        label {
            width: 80px;
            font-size: 14px;
            color: #72777F;
        }
        .class-item {
            padding: 0 20px;
            box-sizing: border-box;
            cursor:pointer;
            height: 36px;
            border-radius: 6px;
            font-size: 14px;
            color: #72777F;
            margin-left: 15px;
            line-height: 36px;
        }
        .class-item.active {
            background-color:  #EDF3FF;
            color: #256CF4;
        }
    }
    .bottom {
        box-sizing: border-box;
        margin: 0 auto;

        .nav {
            width: 100%;
            height: 62px;
            background-color: white;
            padding: 0 30px 0 0;
            margin-top: 20px;
            box-sizing: border-box;
            border-bottom: #F1F2F6 1px solid;

            .nav-tive {
                font-size: 16px;
                color: #72777F;

                .topic {
                    height: 62px;
                    width: 100px;
                }

                .paper {
                    height: 62px;
                    width: 100px;
                }

                .throw {
                    margin-top: 2px;
                    width: 20px;
                    height: 4px;
                    background: #256CF4;
                    border-radius: 2px;
                }

                .avtie {
                    color: #256CF4;
                    margin-top: 4px;
                }
            }

            ::v-deep .el-input {
                .el-input__inner {
                    border-color: #4A78D4;;

                }

                .el-input-group__append {
                    background-color: #256CF4;
                    border: 2px solid #256CF4;
                    color: white;
                }
            }

        }

        .list-body {
            min-height: 65vh;

            .exam-item {
                background: white;
                min-height: 155px;
                margin-bottom: 1px;
                transition: all .2s;
                position: relative;

                &:last-child {
                    margin-bottom: 0;
                }

                &:hover {
                    box-shadow: 0px 15px 30px 0px rgba(186, 192, 202, 0.8);
                    z-index: 50;
                }

                .exam-no {
                    margin-right: 40px;
                    width: 92px;
                    height: 50px;
                    border-right: #E5E8EC 1px solid;
                    font-size: 30px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #256CF4;
                    text-align: center;
                    line-height: 50px;
                }

                .till {
                    color: #2F3134;
                    font-size: 14px;
                    min-width: 263px;
                    padding-right: 10px;

                    .info-item {
                        label {
                            color: #72777F;
                        }

                        .groupName{
                          width: 260px;
                          line-height: 12px;
                          overflow: hidden;
                          white-space: nowrap;
                          display: inline-block;
                          text-overflow: ellipsis;
                        }
                    }

                    .info-item:last-child {
                        margin-top: 10px;
                    }
                }

                button {
                    padding: 0 21px;
                    cursor: pointer;
                    border: none;
                    color: white;
                    font-size: 14px;
                    margin-right: 40px;
                    min-width: 98px;
                    height: 36px;
                    background: linear-gradient(270deg, #4987FF 0%, #4CA5FA 100%);
                    border-radius: 100px;

                    &:active {
                        opacity: 0.8;
                    }

                    &:hover {
                        background: linear-gradient(270deg, #4987FF 40%, #4CA5FA 100%);
                    }

                    &:disabled {
                        background: #E5E8EC;
                        color: #BAC0CA;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }
}
</style>
